import ui from './ui'
import authentication from './authentication'
import newProduct from './newProduct'

export default {
  ui,
  authentication,
  newProduct
}
